import { CommonModule, NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { DsSegmentedControlModule } from '@frontend/ui/segmented-control';
import { DeviceService, NavigationService, TrackingService, UserService } from '@frontend/vanilla/core';
import { Subject, Subscription } from 'rxjs';

import { RewardsHubSegments } from './model';
import { ToggleNavigationService } from './toggle-navigation.service';

const OFFERS_SEGMENT = 'offers';
const REWARDS_ROUTE = '/promo/rewards';

@Component({
    selector: 'toggle-navigation',
    imports: [RouterModule, NgClass, DsSegmentedControlModule, CommonModule],
    templateUrl: './toggle-navigation.component.html',
    styleUrls: ['./toggle-navigation.component.scss'],
})
export class ToggleNavigationComponent implements OnInit, OnDestroy {
    private readonly destroy$ = new Subject<void>();
    private contentLoadedSub?: Subscription;
    rewardsHubSegments!: RewardsHubSegments;
    isDataLoaded: boolean = false;

    constructor(
        private router: Router,
        private navigationService: NavigationService,
        public deviceService: DeviceService,
        public userService: UserService,
        public toggleNavigationService: ToggleNavigationService,
        private trackingService: TrackingService,
    ) {}

    ngOnInit() {
        if (!this.toggleNavigationService.rewardsHubSegments) {
            this.contentLoadedSub = this.toggleNavigationService.isContentLoaded.subscribe({
                next: () => {
                    this.rewardsHubSegments = this.toggleNavigationService.rewardsHubSegments;
                    this.loadNavigation();
                },
            });
        } else {
            this.rewardsHubSegments = this.toggleNavigationService.rewardsHubSegments;
            this.loadNavigation();
        }
    }

    private loadNavigation(): void {
        this.toggleNavigationService.isPromoActive = !this.router.url.includes(REWARDS_ROUTE);
        this.isDataLoaded = true;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.contentLoadedSub) {
            this.contentLoadedSub.unsubscribe();
        }
    }

    onToggleNavigation(selectedSegment: string): void {
        const isOffersSelected = selectedSegment === OFFERS_SEGMENT;

        if (this.toggleNavigationService.isPromoActive !== isOffersSelected) {
            const targetRoute = isOffersSelected ? this.toggleNavigationService.promoOffersRoute : this.toggleNavigationService.rewardsHubRoute;
            this.navigationService.goTo(targetRoute);
            this.trackNavigationEvent(targetRoute, isOffersSelected);
        }
    }

    private trackNavigationEvent(targetRoute: string, isOffersSelected: boolean): void {
        this.trackingService.triggerEvent('Event.Tracking', {
            'event': 'Event.Tracking',
            'component.CategoryEvent': 'promo hub',
            'component.ActionEvent': 'click',
            'component.LabelEvent': 'offer section',
            'component.PositionEvent': 'not applicable',
            'component.LocationEvent': 'not applicable',
            'component.EventDetails': isOffersSelected ? 'promotions' : 'my rewards',
            'component.URLClicked': window.location.origin + targetRoute || 'not applicable',
            'component.ContentPosition': 'not applicable',
            'campaignId': 'not applicable',
            'page.siteSection': 'promo hub',
            'page.siteSubSection': 'promo offers home page',
            'component.PromotionType': '',
            'component.Product': '',
            'component.PromoOfferName': '',
            'component.PromoIntent': '',
        });
    }
}
